<div class="login-page">
    <div class="login-container">
        <div class="login-card">
            <!-- Logo Section -->
            <div class="logo-header">
                <img src="assets/images/lens-blueprint-logo.svg" alt="Lens Blueprint" class="brand-logo"
                    onerror="this.style.display='none'" />
                <h1 class="brand-title">Lens Blueprint</h1>
                <p class="brand-subtitle">Assessment Dashboard</p>
            </div>

            <!-- Login Form -->
            <div class="form-section">
                <h2 class="form-title">Welcome Back</h2>
                <p class="form-description">Sign in to access your dashboard</p>

                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
                    <!-- Error Message -->
                    <div class="error-alert" *ngIf="error">
                        <mat-icon>error_outline</mat-icon>
                        <span>{{ error }}</span>
                    </div>

                    <!-- Email Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Email Address</mat-label>
                        <input matInput formControlName="email" type="email" placeholder="Enter your email" />
                        <mat-icon matSuffix>email</mat-icon>
                        <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
                            Email is required
                        </mat-error>
                        <mat-error *ngIf="loginForm.get('email')?.hasError('email')">
                            Please enter a valid email address
                        </mat-error>
                    </mat-form-field>

                    <!-- Password Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Password</mat-label>
                        <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'"
                            placeholder="Enter your password" />
                        <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hidePassword" type="button">
                            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                        <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
                            Password is required
                        </mat-error>
                        <mat-error *ngIf="loginForm.get('password')?.hasError('minlength')">
                            Password must be at least 6 characters
                        </mat-error>
                    </mat-form-field>

                    <!-- Login Button -->
                    <button mat-raised-button type="submit" [disabled]="!loginForm.valid || loading" class="login-btn">
                        <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
                        <mat-icon *ngIf="!loading">login</mat-icon>
                        <span *ngIf="!loading">Sign In</span>
                    </button>

                    <!-- Forgot Password Link -->
                    <div class="forgot-password-link">
                        <a routerLink="/forgot-password" class="forgot-link">Forgot Password?</a>
                    </div>
                </form>
            </div>

            <!-- Footer -->
            <div class="login-footer">
                <p class="footer-text">
                    Don't have an account?
                    <a routerLink="/register" class="footer-link">Sign up here</a>
                </p>
                <p class="copyright">&copy; {{ currentYear }} Lens Blueprint. All rights reserved.</p>
            </div>
        </div>
    </div>
</div>